<template>

<core-modal v-on:close="onClose" :loading="is.loading && !is.initialised">

	<template v-slot:head>

		Your external domain

	</template>

	<template v-slot:default>

        <p>You must update your domain DNS to point the A record of either the entire domain (* record) or a specific sub-domain record to <b>159.65.111.10</b> and it is recommended to do this immediately to avoid delays to your external domain being approved.</p>

        <p>All external domains will be reviewed prior to being activated to ensure their DNS has been updated correctly. Once approved, you cannot change external domain for at least 7 days.</p>

        <core-form-input-textbox :autofocus="true" maxlength="24" name="name" v-on:validate="validate" placeholder="Enter external domain" v-model="model.name" />
		
	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="!isPending">Send Request</core-button>
		<core-button theme="blue" :loading="is.loading" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="isPending">Update Request</core-button>
        <core-button theme="red" :loading="is.cancelling" v-on:click.native="onCancelClick" v-if="isPending">Cancel Request</core-button>
        <core-button theme="red" :loading="is.cancelling" v-on:click.native="onCancelClick" v-if="isAccepted">Remove external domain</core-button>

	</template>

</core-modal>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {

			is: {
				loading: false,
                initialised: false,
                cancelling: false
			},
                
            model: {
                name: ''
            },

            data: {}

		}

	},

    created: function() {

        this.load()

    },

    computed: {

        isValid: function() {

            return this.model.name.length > 2

        },

        isPending: function() {

            return (this.data.user) ? !this.data.user.status : false

        },

        isAccepted: function() {

            return (this.data.user) ? this.data.user.status : false

        }

    },

	methods: {

        load: function() {

            this.is.loading = true
            
            this.$api.get('session/externaldomains').then(function(json) {

                if (json.user) {

                    this.model.name = json.user.value

                }

                Vue.set(this, 'data', json)

                this.is.loading = false
                this.is.initialised = true

            }.bind(this), function() {
                
                this.$emit('close')

            }.bind(this))

        },

        onConfirmClick: function() {

            this.is.loading = true
            
            this.$api.post('session/externaldomains', {
                type: 'user',
                value: this.model.name
            }).then(function() {

                this.$pubsub.$emit('session.patreon.externaldomains')

                this.$emit('close')

            }.bind(this), function() {
                
                this.$notify({
					message: 'Sorry, this externaldomain has been taken.',
					type: 'error'
				})

                this.is.loading = false

            }.bind(this))

        },
        
        onCancelClick: function() {

            this.is.cancelling = true
            
            this.$api.delete('session/externaldomains', {
                type: 'user'
            }).then(function() {

                this.$pubsub.$emit('session.patreon.externaldomains')

                this.$emit('close')

            }.bind(this), function() {
                
                this.$pubsub.$emit('session.patreon.externaldomains')

                this.$emit('close')

            }.bind(this))

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.group {
    margin-bottom: 20px;
    display: block;
    cursor: pointer;
}

.group.is-disabled {
    opacity: 0.25;
    pointer-events: none;
}

.groups-empty {
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    padding: 20px 0px;
}

.group:last-child {
    margin-bottom: 0px;
}

.group-name {
    border-radius: 4px;
    padding: 10px 50px 10px 10px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.25);
}

.group.is-selected .group-name {
    background-color: #48bb6d;
}

.group:hover .group-name {
    background-color: rgba(0, 0, 0, 0.45);
}

.group.is-selected:hover .group-name {
    background-color: #48bb6d;
}

.group-name i.fa-check {
    position: absolute;
    right: 15px;
    top: 0px;
    line-height: 36px;
}

.group-name i.fa-rocket-launch {
    position: absolute;
    right: 15px;
    top: 6px;
    color: #082534;
    background-color: #ffc563;
    border-radius: 50%;
    width: 24px;
    font-size: 14px;
    height: 24px;
    text-align: center;
    line-height: 24px;
}

.group-metrics {
    display: grid;
    margin-top: 4px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 4px;
}

.group-metrics-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.25);
    justify-content: center;
    padding: 10px 0px;
    border-radius: 4px;
}

.group-metrics-item i {
    font-size: 14px;
    color: #fff;
    opacity: 0.75;
}

.group-metrics-item span {
    font-size: 18px;
    color: #fff;
    font-weight: 400;
    margin-bottom: 8px;
}

</style>